<div class="quick-bet-confirmation-header">
    <vn-icon class="success-icon" name="sports-check" size="16"></vn-icon>
    <span>{{ sitecore.quickBetMessages.BetPlaceSuccessText }}</span>
    <button
        msThemedIconButton
        ds-button-icon
        size="large"
        variant="flat"
        kind="tertiary"
        [themeInverse]="closeButtonThemeInverse"
        (click)="closeResultScreen()">
        <vn-icon name="theme-ex" size="16"></vn-icon>
    </button>
</div>
@if (summaryViewModel$ | async; as summaryViewModel) {
    <div class="quick-bet-confirmation-picks-information">
        <span class="quick-bet-confirmation-pick-header">{{ pickInfo().header }}</span>
        <span class="quick-bet-confirmation-pick-option">{{ pickInfo().option }}</span>
        @if (summaryViewModel.startingPrice.hasStartingPrice) {
            <div class="quick-bet-confirmation-odds">
                <span>{{ summaryViewModel.startingPrice.startingPriceTitle }}</span>
            </div>
        }
        @if (isSinglePickPriceBoost()) {
            <div class="quick-bet-confirmation-price-boost">
                <span class="was-price was-price-betslip"> {{ priceBeforeBoostOdds() }}</span>
                <ms-priceboost-count-signpost [count]="priceBoostOdds()" [isLargeSignPost]="true"></ms-priceboost-count-signpost>
            </div>
        } @else {
            <bs-result-odds
                class="quick-bet-odds"
                [odds]="summaryViewModel.summary.odds?.value"
                [boostedOdds]="summaryViewModel.summary.odds?.boosted"
                [oddsDisplayFormat]="oddsDisplayFormat"></bs-result-odds>
        }
    </div>
    @if (marketLogoInfo().showLogo) {
        <div class="quick-bet-confirmation-marketsubtype-logo">
            <ms-marketsubtype-logo
                [eventId]="marketLogoInfo().pick!.id.fixtureId"
                [marketType]="marketLogoInfo().pick!.market.marketType"
                [marketSubType]="marketLogoInfo().pick!.market.marketSubType"
                [templateId]="marketLogoInfo().pick!.market.templateId"
                [matchName]="marketLogoInfo().pick!.eventName.name"
                [sportId]="marketLogoInfo().pick!.sportId"
                [trackingLocation]="'quickbet'"
                [tooltipAppendTo]="'bs-quick-bet'"
                [tooltipBoundaries]="'bs-quick-bet'"
                [tooltipPlacement]="'top-start'" />
        </div>
    }
    <hr class="line-separator" />
    <bs-digital-result-summary
        class="quick-bet-result-summary"
        [viewModel]="summaryViewModel.summary"
        [oddsDisplayFormat]="oddsDisplayFormat"
        [isQuickBetConfirmation]="true"></bs-digital-result-summary>
}
